import { Preview } from "../../../../types/IAction";
import * as actions from "../../../actions/comisionMembresia";
import {
  PostComisionMembresiaCargaMetas,
  GetComisionMembresiaMetas,
  GetComisionMembresiaMetasActuales
} from "../../../reducers/comisionMembresia";

export interface ConfiguracionMetasDispatcher {
  postCargaMetas: (
    formData: FormData,
    confirmar: boolean
  ) => Promise<Preview<PostComisionMembresiaCargaMetas>>;
  getMetas: () => Promise<Preview<GetComisionMembresiaMetas>>;
  getMetasActuales: () => Promise<Preview<GetComisionMembresiaMetasActuales>>;
  clearMetas: () => void;
}

export const configuracionMetasDispatcher: (
  dispatch: (...args) => Promise<Preview<any>>
) => ConfiguracionMetasDispatcher = dispatch => ({
  postCargaMetas: (formData: FormData, confirmar: boolean) => {
    return dispatch(actions.postCargaMetas(formData, confirmar));
  },
  getMetas: () => {
    return dispatch(actions.getMetas());
  },
  getMetasActuales: () => {
    return dispatch(actions.getMetasActuales());
  },
  clearMetas: () => {
    return dispatch(actions.clearMetas());
  }
});
